export interface InvoicesPanelStateModel {
  visibleColumns: string[];
}

export class SetVisibleColumns {
  static readonly type = '[InvoicesPanel] Set Visible Columns';

  constructor(public columns: string[]) {}
}
